import React, { Fragment, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb';
import { Card, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { IndexBrands } from './IndexBrands';
import { IndexInfoAnalytes } from './IndexInfoAnalytes';
import { IndexAppCodes } from './IndexAppCodes';
import { IndexMethods } from './IndexMethods';
import { IndexCharacteristic } from './IndexCharacteristic';
import { MachineModelConfigurationCopy } from './MachineModelConfigurationCopy';
// import { IndexMachine as ComponentMachine } from '../../machine/IndexMachine';


export const IndexAnalytes = (props) => {

    const [activeTab, setActiveTab] = useState("1");
    const [copyInProgress, setCopyInProgress] = useState(false);
    const [appCodesVersion, setAppCodesVersion] = useState(0);

    const toggleTab = tab => {
        if (!copyInProgress && activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <Fragment>
            {/* <Breadcrumb parent="Diseño" title="Diseño de analitos" /> */}
            <Container fluid={true}> <br />
                <Row>
                    <Col md="12">
                        {/* <Card> */}
                        <Nav className="nav-primary nav-fill flex-column flex-md-row round" tabs aria-label="Diseño de analitos">
                            <NavItem>
                                <NavLink disabled={copyInProgress} href="#javascript" role="tab" className={activeTab === "1" ? 'active' : ''} onClick={() => toggleTab("1")}><i className="fa fa-cog"></i> Marcas</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink disabled={copyInProgress} href="#javascript" role="tab" className={activeTab === "4" ? 'active' : ''} onClick={() => toggleTab("4")}><i className="fa fa-building-o"></i>Métodos</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink disabled={copyInProgress} href="#javascript" role="tab" className={activeTab === "2" ? 'active' : ''} onClick={() => toggleTab("2")}><i className="fa fa-building-o"></i>Analitos</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink disabled={copyInProgress} href="#javascript" role="tab" className={activeTab === "5" ? 'active' : ''} onClick={() => toggleTab("5")}><i className="fa fa-building-o"></i>Caracteristicas</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink disabled={copyInProgress} href="#javascript" role="tab" className={activeTab === "3" ? 'active' : ''} onClick={() => toggleTab("3")}><i className="fa fa-building-o"></i>Vinculación de analitos</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink href="#javascript" role="tab" aria-selected={activeTab === "6"} className={activeTab === "6" ? 'active' : ''} onClick={() => toggleTab("6")}><i className="fa fa-copy" aria-hidden="true"></i>Copiar configuración</NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane className="fade show" tabId="1"> <br />
                                <IndexBrands
                                    {...{ ...props, activeTab }}
                                />
                            </TabPane>
                            <TabPane className="fade show" tabId="2"> <br />
                                <IndexInfoAnalytes
                                    {...{ ...props, activeTab }}
                                />
                            </TabPane>
                            <TabPane className="fade show" tabId="3"> <br />
                                <IndexAppCodes
                                    key={appCodesVersion}
                                    {...{ ...props, activeTab }}
                                />
                            </TabPane>
                            <TabPane className="fade show" tabId="6"> <br />
                                {activeTab === "6" && <MachineModelConfigurationCopy
                                    onCancel={() => toggleTab("3")}
                                    onBusyChange={setCopyInProgress}
                                    onCopyCompleted={() => setAppCodesVersion(version => version + 1)}
                                />}
                            </TabPane>
                            <TabPane className="fade show" tabId="4"> <br />
                                <IndexMethods
                                    {...{ ...props, activeTab }}
                                />
                            </TabPane>
                            <TabPane className="fade show" tabId="5"> <br />
                                <IndexCharacteristic
                                    {
                                    ...{
                                        ...[props, activeTab]
                                    }
                                    }
                                />
                            </TabPane>
                        </TabContent>
                        {/* </Card> */}
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
